import styled from 'styled-components';

export const BankSlipPaymentContainer = styled.div`
	border-top-right-radius: inherit;
	border-top-left-radius: inherit;
	overflow-wrap: anywhere;
	word-break: break-word;
`;

export const Header = styled.div`
	border-top-right-radius: inherit;
	border-top-left-radius: inherit;
	/* Mesmo valor do header de PixPayment. O GlobalStyle nao tem token equivalente
	   (--ticto-shape-dark e #f7f7f7, mais claro), e trocar romperia a paridade
	   visual entre as duas telas de cobranca pendente. */
	background-color: #edf2f7;
	padding: 0.875rem 1rem;
`;

export const Title = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: auto;
	gap: 0.625rem;

	h3 {
		width: auto;
		margin: 0;
		font-size: 1.0625rem;
		font-weight: 600;
		line-height: 1.3;
		letter-spacing: -0.01em;
		color: var(--ticto-title) !important;
	}

	svg {
		flex: 0 0 auto;
		color: var(--ticto-green);
		width: 22px !important;
		height: 22px !important;
	}
`;

/**
 * O conteudo e um empilhamento de grupos, nao de itens: o gap base separa grupos
 * distintos e cada grupo aperta o proprio espacamento interno. Um gap uniforme
 * daria o mesmo peso ao dado que o comprador precisa copiar e ao rodape de
 * identificadores do pedido.
 */
export const Content = styled.div`
	padding: 1.25rem 1.25rem 1rem;
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 1.25rem;
	overflow-wrap: anywhere;
	word-break: break-word;
`;

/** Nucleo do pagamento: vencimento, linha digitavel e a acao de copiar. */
export const PaymentBlock = styled.div`
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 0.5rem;
`;

export const DueDate = styled.p`
	margin: 0;
	text-align: center;
	line-height: 1.4;

	/* Bloco, nao flex: o separador entre rotulo e data precisa existir no texto,
	   nao apenas como gap, para o leitor de tela anunciar a pausa. */
	span,
	strong {
		width: auto;
		display: inline;
	}

	span {
		font-size: 0.6875rem;
		font-weight: 600;
		letter-spacing: 0.06em;
		text-transform: uppercase;
		color: var(--ticto-title) !important;
	}

	strong {
		font-size: 0.9375rem;
		font-weight: 600;
		font-variant-numeric: tabular-nums;
		color: var(--ticto-text) !important;
	}
`;

export const CompensationNotice = styled.p`
	margin: 0;
	text-align: center;
	font-size: 0.75rem;
	line-height: 1.4;
	color: var(--ticto-title) !important;
`;

/**
 * A linha digitavel e o dado mais importante da tela — e o que o comprador copia
 * ou digita no app do banco. Vem sem separadores (onlyNumbers), entao a
 * legibilidade depende de escala, tracking e altura de linha generosos.
 */
export const DigitableLine = styled.div`
	border-radius: 0.5rem;
	border: 1px solid var(--ticto-input-border);
	background: var(--ticto-shape-dark);
	padding: 0.75rem 0.875rem;
	text-align: center;
	font-size: 0.9375rem;
	font-weight: 500;
	line-height: 1.6;
	letter-spacing: 0.04em;
	font-variant-numeric: tabular-nums;
	color: var(--ticto-text) !important;
	cursor: pointer;
	overflow-wrap: anywhere;
	word-break: break-word;
	white-space: normal;
	width: 100%;
	max-width: 100%;
	box-sizing: border-box;
	transition: border-color 0.2s, background 0.2s;

	&:hover {
		border-color: var(--ticto-green);
		background: var(--ticto-shape);
	}
`;

export const EmailNotice = styled.p`
	margin: 0;
	font-size: 0.875rem;
	line-height: 1.5;
	text-align: center;
	color: var(--ticto-text) !important;
	white-space: normal;
`;

/**
 * Acesso ao boleto completo. A enfase segue a importancia no contexto, nao o
 * papel fixo do controle: com a linha digitavel em tela, copiar e a acao primaria
 * e este vira contorno, porque dois botoes solidos competiriam pela mesma
 * decisao. Sem a linha digitavel, este e o unico caminho de pagamento na tela e
 * assume o peso primario.
 */
export const BankSlipAction = styled.a<{ $emphasis: 'primary' | 'secondary' }>`
	border-radius: 8px;
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 0.5rem;
	padding: 0 18px;
	border: 2px solid var(--ticto-green);
	background: ${({ $emphasis }) => ($emphasis === 'primary' ? 'var(--ticto-green)' : 'transparent')};
	color: ${({ $emphasis }) =>
		$emphasis === 'primary' ? 'var(--ticto-white)' : 'var(--ticto-green)'} !important;
	font-size: 15px;
	font-weight: 500;
	text-decoration: none !important;
	cursor: pointer;
	transition: background 0.2s, filter 0.2s, transform 0.2s;

	&:hover {
		background: ${({ $emphasis }) =>
			$emphasis === 'primary' ? 'var(--ticto-green)' : 'var(--ticto-green-light)'};
		filter: brightness(1.08);
	}

	svg {
		flex: 0 0 auto;
		max-width: 1.25rem;
	}
`;

/**
 * Identificadores do pedido: informacao de suporte, nao de pagamento. Divisor e
 * escala reduzida tiram o peso que competia com a linha digitavel, sem alterar o
 * TransactionDetails, que e compartilhado com a tela de Pix.
 */
export const DetailsWrapper = styled.div`
	border-top: 1px solid var(--ticto-outline);
	padding-top: 1rem;

	p {
		font-size: 0.78rem;
		line-height: 1.6;
	}
`;

export const CloseRow = styled.div`
	display: flex;
	justify-content: center;
	padding-top: 0.25rem;
`;
